import { Inject, Injectable } from "@angular/core";
import { SpinnerBaseComponent } from "@app/components/spinner/spinner.base.component";
import { SpinnerReconnectComponent } from "@app/components/spinner/spinner.reconnect.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { take } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class SpinnerService {

    dialogRef: MatDialogRef<any>;

    constructor(@Inject(MatDialog) private dialog: MatDialog) {}

    showSpinner() {
        if (this.dialogRef === undefined || this.dialogRef.getState() !== 0) {
            this.dialogRef = this.dialog.open(SpinnerBaseComponent, {
                closeOnNavigation: false,
                disableClose: true,
            })
            this.dialogRef.afterOpened().pipe(take(1)).subscribe(() => {
                Loader.init();
            });
        }
    }

    closeSpinner() {
        try{
            this.dialogRef.close();
        } catch(_error) {}
    }

    showReconnecting() {
        this.closeSpinner();
        this.dialog.open(SpinnerReconnectComponent, {
            closeOnNavigation: false,
            disableClose: true,
        })
    }
}

